export default "__VITE_ASSET__DSh5aUWH__"